<template>
  <b-form-group
      :label="$t('Status')"
      label-for="status"
      :readonly="readonly"
      :state="error ? false : null"
      :invalid-feedback="error"
  >
    <b-form-select
        id="status"
        :value="value"
        name="status"
        :options="options"
        :state="error ? false : null"
        @input="$emit('input', $event)"
    >
      <template #first>
        <b-form-select-option :value="null">
          {{ $t('All') }}
        </b-form-select-option>
      </template>
    </b-form-select>
  </b-form-group>
</template>

<script>
import {PROJECT_STATUSES} from "@/constants";

export default {
name: "ProjectStatusSelect",
  props: ['value', 'error', 'readonly'],
  computed: {
    options() {
      return Object.values(PROJECT_STATUSES).map(status => {
        return {
          value: status,
          text: this.$t(status),
        }
      })
    }

  }
}
</script>